import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a579754c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-content-base" }
const _hoisted_2 = { class: "page-content-base__content" }
const _hoisted_3 = {
  key: 0,
  class: "page-content-base__summary"
}
const _hoisted_4 = {
  key: 1,
  class: "page-content-base__sections"
}
const _hoisted_5 = {
  key: 2,
  class: "page-content-base__body"
}

import PageSectionNavigator from '@/layout/_shared/PageSectionNavigator.vue';
import { providePageSectionNav } from '@/layout/_shared/usePageSectionNav';


export default /*#__PURE__*/_defineComponent({
  __name: 'PageContentBase',
  props: {
  plain: {
    type: Boolean,
    default: false,
  },
  sectionNav: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

/**
 * PageContentBase
 *
 * Page content wrapper as a child of `#kt_content_container`.
 * Page title/actions + optional banner live in `#kt_header` via
 * `usePageToolbar` / `PageToolbarHeader`.
 *
 * Props:
 * - plain: skip the single white card; use with PageContentSection children
 * - sectionNav: enable floating right section navigator when plain (default true)
 *
 * Slots: summary, default (body)
 */
const props = __props;

const sectionNav =
  props.plain && props.sectionNav ? providePageSectionNav() : null;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["page-content-base__inner page-content-base__main", { 'page-content-base__main--plain': __props.plain }])
      }, [
        (_ctx.$slots.summary)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _renderSlot(_ctx.$slots, "summary")
            ]))
          : _createCommentVNode("", true),
        (__props.plain)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _renderSlot(_ctx.$slots, "default")
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _renderSlot(_ctx.$slots, "default")
            ]))
      ], 2)
    ]),
    (_unref(sectionNav))
      ? (_openBlock(), _createBlock(PageSectionNavigator, {
          key: 0,
          nav: _unref(sectionNav)
        }, null, 8, ["nav"]))
      : _createCommentVNode("", true)
  ]))
}
}

})